import { render, staticRenderFns } from "./ProductivesHoursReport.vue?vue&type=template&id=40406368&"
import script from "./ProductivesHoursReport.vue?vue&type=script&lang=js&"
export * from "./ProductivesHoursReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports